module.exports = __webpack_public_path__ + "img/CT.Bridges.Substructure.Cantilever_Wall_Abutment.Reinforced_Concrete.4ebdd931.png";